import { createSelector } from "@ngrx/store";
import { IAppState } from "app/IAppState";

const migrateSelector = (state: IAppState) =>
  state.migrateStakeholders;

export const getStatus = createSelector(
  migrateSelector,
  (state: IMigrateStakeholders) => state.status
);

export const getProgress = createSelector(
  migrateSelector,
  (state: IMigrateStakeholders) => state.progress
);
